import { Component, Input, AfterViewInit, OnDestroy } from "@angular/core";
import { DataTable } from "primeng/primeng";
import { PaginationOption } from "@models/common";
import { Subscription } from "rxjs/Subscription";

@Component({
    templateUrl: "./datatable-paginator.component.html",
    selector: "app-datatable-paginator"
})

export class DataTablePaginator implements AfterViewInit, OnDestroy {
    currentPage: number = 0;
    opts: PaginationOption[] = [];
    initialized: boolean = false;
    pageChangeSub: Subscription;

    @Input() dt: DataTable;

    ngAfterViewInit(): void {
        this.updateComponent();
        this.subscribeToPageChanges();
    }

    ngOnDestroy() {
        if (this.pageChangeSub != undefined) {
            this.pageChangeSub.unsubscribe();
        }
    }

    subscribeToPageChanges(): void {
        if (this.dt != undefined) {
            this.pageChangeSub = this.dt.valueChange.subscribe(x => {
                setTimeout(() => this.updateComponent());
            });
        } else {
            setTimeout(() => this.subscribeToPageChanges(), 100);
        }
    }

    updateComponent() {
        if (this.dt != undefined) {
            this.updateCurrentPage();
            let totalPages = this.getTotalPages();
            this.opts = [];

            let prev: PaginationOption = {
                display: "<",
                value: this.currentPage - 1,
                disabled: (this.currentPage - 1) <= 0
            };
            this.opts.push(prev);

            let page = this.currentPage;

            let pages = [page - 2, page - 1, page, page + 1, page + 2];

            if (page + 1 > totalPages) {
                pages.push(page - 3);
                pages.push(page - 4);
            } else if (page + 2 > totalPages) {
                pages.push(page - 3);
            }

            if (page - 1 <= 0) {
                pages.push(page + 3);
                pages.push(page + 4);
            } else if (page - 2 <= 0) {
                pages.push(page + 3);
            }

            pages.sort((a, b) => {
                return a - b;
            });

            for (let i = 0; i < pages.length; i++) {
                let item = pages[i];
                if (item > 0 && item <= totalPages) {
                    let opt: PaginationOption = {
                        display: item.toString(),
                        value: item,
                        disabled: false
                    };

                    this.opts.push(opt);
                }
            }

            let next: PaginationOption = {
                display: ">",
                value: this.currentPage + 1,
                disabled: (this.currentPage + 1) > this.getTotalPages()
            };
            this.opts.push(next);

            if (this.opts.length <= 2) {
                setTimeout(() => this.updateComponent(), 100);
                return;
            }

            if (!this.initialized) {
                setTimeout(() => this.initialized = true, 0);
            }

        } else {
            setTimeout(() => this.updateComponent(), 100);
        }
    }

    paginate(value: number): void {
        let rows = this.dt.rows;
        let first = (value - 1) * rows;
        let page = {
            first: first,
            rows: rows
        };
        this.dt.onPageChange(page);
    }

    getTotalPages(): number {
        return Math.ceil(this.dt._totalRecords / this.dt.rows);
    }

    updateRows() {
        this.paginate(1);
    }

    updateCurrentPage(): void {
        let first = this.dt._first;
        let pageLength = this.dt.rows;

        let pages = 0;
        while ((first - (pageLength * pages)) >= 0) {
            pages++;
        }

        if (pages === 0) {
            pages = 1;
        }
        this.currentPage = pages;
    }
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/datatable-paginator/datatable-paginator.component.ts